import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  ButtonGroup,
  Column,
  Columns,
  Container,
  TextInput,
} from '@resurs/midas-react'
import Page from '../../../internal/Page'
import PageActionBar from '../../../internal/PageActionBar'
import styles from './styles.module.scss'
import { RoleLabels } from '../../../models/roles'
import { getText } from '../../../internal/TextLabels'
import {
  ProfileSettingsForm,
  ProfileSettingsModel,
} from '../../../models/profileForm'

const ProfileInfo = props => {
  const formModel = new ProfileSettingsModel()
  const formEntries = new ProfileSettingsForm(props.me.role.name)
  const roleLabels = new RoleLabels()

  const [initialInfo, setInitialInfo] = useState(props.me)
  const [info, setInfo] = useState(props.me)
  const [changed, setChanged] = useState(false)
  const [valid, setValid] = useState(new ProfileSettingsModel())
  const [edit, setEdit] = useState(props.edit)

  const onSave = () => {
    setEdit(false)
    props.onSave(info)
  }

  const onFormEntryChange = (value, property) => {
    const newInfo = { ...info, [property]: value }
    setInfo(newInfo)
    setChanged(
      Object.keys(newInfo)
        .filter(key => Object.keys(formModel).includes(key))
        .some(key => newInfo[key] !== initialInfo[key]),
    )
  }

  const initFormValidation = () => {
    setValid(
      Object.keys(valid).reduce((prev, key) => {
        if (
          (info[key] === '' || info[key] === undefined) &&
          !formEntries.isRequired[key]
        ) {
          return { ...prev, [key]: true }
        }
        return {
          ...prev,
          [key]: new RegExp(formEntries.format[key].regex).test(info[key]),
        }
      }, {}),
    )
  }

  useEffect(() => {
    initFormValidation()
  }, [])

  useEffect(() => {
    setInitialInfo(props.me)
    setInfo(props.me)
    setChanged(false)
    initFormValidation()
  }, [props.me])

  const resetForm = () => {
    setInfo(initialInfo)
    setChanged(false)
    setEdit(false)
  }

  const updateEntryValidationState = itemValidation => {
    if (valid[itemValidation.key] !== itemValidation.valid) {
      setValid({ ...valid, [itemValidation.key]: itemValidation.valid })
    }
  }

  const isDisabled = !(Object.keys(valid).every(key => !!valid[key]) && changed)

  return (
    <Page title={getText('profile.title')}>
      {props.topSaveButton && (
        <PageActionBar
          actions={
            <ButtonGroup spacing>
              {!edit ? (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => setEdit(!edit)}
                >
                  {getText('default.edit')}
                </Button>
              ) : (
                <>
                  <Button
                    size="small"
                    text={getText('default.cancel')}
                    onClick={resetForm}
                  />
                  <Button
                    size="small"
                    type="primary"
                    kind="success"
                    text={getText('default.save')}
                    form
                    onClick={onSave}
                    disabled={isDisabled}
                  />
                </>
              )}
            </ButtonGroup>
          }
        />
      )}
      <Container>
        <Columns>
          <Column col12>
            <Columns>
              <Column col12>
                <dt className={styles.descriptiveTableHeader}>
                  {getText('profile.role')}
                </dt>
                <dd className={styles.descriptiveTableContent}>
                  {roleLabels.labels[info.role.name]}
                </dd>
              </Column>
              <Column col12>
                <dt className={styles.descriptiveTableHeader}>
                  {props.stores.length > 1
                    ? getText('user.stores')
                    : getText('user.store')}
                </dt>
                {props.stores.map(store => (
                  <dd className={styles.descriptiveTableContent} key={store.id}>
                    {store.name}
                  </dd>
                ))}
              </Column>
            </Columns>
            <form
              onSubmit={e => {
                e.preventDefault()
              }}
            >
              {Object.keys(formModel).map(key => (
                <TextInput
                  key={key}
                  id={key}
                  label={formEntries.labels[key]}
                  value={info[key]}
                  format={formEntries.format[key]}
                  isValid={updateEntryValidationState}
                  onChange={e => onFormEntryChange(e.target.value, key)}
                  required={
                    formEntries.isRequired[key]
                      ? getText('default.form.required')
                      : null
                  }
                  disabled={!edit}
                />
              ))}
            </form>
          </Column>
        </Columns>
      </Container>
      <div className={styles.centerSaveButton}>
        {!props.topSaveButton && (
          <Button
            type="primary"
            text={getText('default.save')}
            form
            onClick={onSave}
            disabled={isDisabled}
          />
        )}
      </div>
    </Page>
  )
}

ProfileInfo.propTypes = {
  me: PropTypes.object.isRequired,
  stores: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  topSaveButton: PropTypes.bool,
}

ProfileInfo.defaultProps = {
  edit: false,
  topSaveButton: true,
}

export default ProfileInfo
